// src/Components/constants/regions.ts
// 3 miền cố định dùng cho Cơ cấu Giải thưởng / Kết quả Quay số (payout-service) — khớp đúng chuỗi
// PayoutRegions bên payout-service (PayoutService/PayoutRegions.cs).

import { CacheService } from 'services/cache';
import { CacheConfig } from 'services/cache/CacheConfig';
import { SystemConfiguration } from 'pages/SystemConfiguration/types';

export const REGIONS = ['Miền Bắc', 'Miền Trung', 'Miền Nam'] as const;
export type Region = (typeof REGIONS)[number];

export const DEFAULT_REGION: Region = 'Miền Bắc';

/**
 * Đọc miền mặc định từ cache lms_cache_system_config (SystemConfiguration.region) để pre-select dropdown
 * chọn miền ở Cơ cấu Giải thưởng/Kết quả Quay số — chỉ dùng làm gợi ý ban đầu, người dùng có thể đổi sang
 * miền khác. Nếu giá trị cache không khớp đúng 1 trong 3 miền cố định (VD: region đang là tên loại vé tự do),
 * fallback về DEFAULT_REGION.
 */
export const getDefaultRegion = (): Region => {
  const cached = CacheService.get<SystemConfiguration>(CacheConfig.SYSTEM_CONFIG.key);
  // .normalize('NFC') để tránh lệch giữa 2 cách encode dấu tiếng Việt (dựng sẵn vs tổ hợp) khiến so sánh
  // strict-equal thất bại âm thầm dù nhìn giống hệt nhau — rơi về DEFAULT_REGION mà không báo lỗi gì.
  const cachedRegion = cached.data?.region?.trim().normalize('NFC');
  return (REGIONS as readonly string[]).includes(cachedRegion || '') ? (cachedRegion as Region) : DEFAULT_REGION;
};
